export class SellerLayout {
    id: number;
    name: string;
    layout: string;
    isGridView: boolean;
    isDefault: boolean;

    // Client-side only
    text: string;

    constructor(id: number, name: string, layout: string, isGridView: boolean, isDefault: boolean) {
        this.id = id;
        this.name = name;
        this.text = name;
        this.layout = layout;
        this.isGridView = isGridView;
        this.isDefault = isDefault;
    }
}
